import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

/**
 * Компонент для инициализации кастомных panes до добавления слоев
 * Должен монтироваться внутри MapContainer перед всеми остальными компонентами слоев
 */
const PaneInitializer = () => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    const panes = map.getPanes();

    // Создаем все необходимые panes в правильном порядке (от большего z-index к меньшему)
    const panesToCreate = [
      { name: 'printingBoundsPane', zIndex: 5000 },
      { name: 'printingGridPane', zIndex: 4000, pointerEvents: 'none' },
      { name: 'drawingPane', zIndex: 510, pointerEvents: 'none' },
      { name: 'tasksPane', zIndex: 505 },
      { name: 'transformersPane', zIndex: 504 },
      { name: 'pillarsPane', zIndex: 503 },
      { name: 'substationsPane', zIndex: 502 },
      { name: 'otherPane', zIndex: 501 },
      { name: 'resPane', zIndex: 500 },
      // { name: 'shadowPane', zIndex: 300, pointerEvents: 'none' },
    ];

    panesToCreate.forEach(({ name, zIndex, pointerEvents }) => {
      if (!panes[name]) {
        const pane = map.createPane(name);
        pane.style.zIndex = zIndex;
        if (pointerEvents) {
          pane.style.pointerEvents = pointerEvents;
        }
        console.log(`✓ Created pane: ${name} with z-index: ${zIndex}`);
      }
    });
  }, [map]);

  return null; // Этот компонент не рендерит ничего
};

export default PaneInitializer;

